import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { ModernButton } from "./DefaultImports";

// 🔧 Garante que o backdrop da confirmação fique acima de outros modais
const ConfirmationModalStyles = createGlobalStyle`
  .modal-backdrop.confirmation-backdrop {
    z-index: 1055 !important;
  }
`;

const StyledModal = styled(Modal)`
  z-index: 99999 !important;

  .modal-dialog {
    max-width: 400px;
    margin: ${({ $topSpacing }) => $topSpacing || "20px auto"};
  }

  .modal-content {
    border-radius: 7px;
    border: none;
    box-shadow: 0 12px 52px rgba(0, 0, 0, 0.1);
  }

  .modal-header {
    background-color: #ee754c;
    border: none;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
  }

  .modal-title {
    font-weight: bold;
    font-size: 18px;
    color: #faf6e9;
  }

  .modal-body {
    padding: 1rem;
    font-size: 15px;
    color: #333;
  }

  .modal-footer {
    background-color: white;
    border: none;
    padding: 0.75rem 1rem;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
`;

const CloseIcon = styled(FontAwesomeIcon).attrs({ icon: faXmark })`
  position: absolute;
  right: 22px;
  font-size: 25px;
  color: #faf6e9;
  cursor: pointer;
  transition: color 0.2s ease;
`;

export const ConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  title = false,
  body = false,
  confirmLabel = false,
  cancelLabel = false,
  confirmColor = false,
  cancelColor = false,
  onCancel = null,
  topSpacing = null,
  centered = !topSpacing,
  blockCloseButton = false,
}) => {
  if (!show) return null;

  return (
    <>
      <ConfirmationModalStyles />
      <StyledModal
        show={show}
        onHide={onHide}
        centered={centered}
        backdrop="static"
        keyboard={false}
        $topSpacing={topSpacing}
        backdropClassName="confirmation-backdrop"
      >
        <div className="modal-header">
          {title && <h5 className="modal-title">{title}</h5>}
          {blockCloseButton ? (
            <></>
          ) : (
            <CloseIcon role="button" onClick={onHide} />
          )}
        </div>

        {body && <div className="modal-body">{body}</div>}

        <div className="modal-footer">
          {cancelLabel && (
            <ModernButton
              color={cancelColor}
              fontSize="14px"
              onClick={onCancel || onHide}
            >
              {cancelLabel}
            </ModernButton>
          )}
          {confirmLabel && (
            <ModernButton
              color={confirmColor}
              fontSize="14px"
              onClick={onConfirm}
            >
              {confirmLabel}
            </ModernButton>
          )}
        </div>
      </StyledModal>
    </>
  );
};
